function OnsiteUiFilterService($rootScope, onsiteSettingsService) {

    var displayOptionsProto = {
            showComments: false,
            showActiveOnly: false,
            sortField: 'timeIn',
            sortDirection: 'desc'
        },
        fieldNames = {
            DURATION: 'duration',
            PHONE_NUMBER: 'phoneNumber',
            SITE_CODE: 'siteCode',
            SITE_NAME: 'siteName',
            TIME_IN: 'timeIn',
            TIME_OUT: 'timeOut',
            USERNAME: 'userName'
        },
        masterDisplayOptions = {
            levelOneWarning: 8,
            levelTwoWarning: 24,
            showComments: true,
            showActiveOnly: false
        },
        sortDirection = {
            ASC: 'asc',
            DESC: 'desc'
        },
        tables = {};

    this.filterActiveOnly = function (visits) {
        return visits.filter(function (item) {
            return !item.timeOut;
        });
    };

    this.getMasterDisplayOptions = function () {
        return masterDisplayOptions
    };

    this.setMasterDisplayOptions = function (displayOptions) {
        masterDisplayOptions = displayOptions;
        $rootScope.$broadcast('master-display-options-changed', masterDisplayOptions);
    };

    this.getTableDisplayOptions = function (tableName) {
        if (!tables[tableName]) {
            tables[tableName] = _.create({}, displayOptionsProto);
        }
        return tables[tableName];
    };

    this.setTableDisplayOptions = function (tableName, options) {
        tables[tableName] = options;
        $rootScope.$broadcast('table-' + tableName + '-display-options-changed', options);
    };


    this.transformVisitsBySite = function (visits) {
        return visits.reduce(function(previous, visit){
            var found = previous.find(function(site){
               return site.siteCode === visit.siteCode;
            });

            if(found){
                found.visits = found.visits.concat(visit);
            }else{
                previous = previous.concat({
                    siteName: visit.siteName,
                    siteCode: visit.siteCode,
                    displayName: visit.siteName + " [" + visit.siteCode + "] ",
                    visits: [visit]
                })
            }
            return previous;
        },[]);
    };

    this.sortSites = function (sortBy, sites) {
        if (sortBy !== fieldNames.SITE_CODE && sortBy !== fieldNames.SITE_NAME) {
            sortBy = fieldNames.SITE_NAME;
            console.warn("Invalid sort option provided. Defaulting to sort by siteName.");
        }

        return sites.sort(function (a, b) {
            if (a[sortBy] === b[sortBy]) {
                return 0;
            }

            return (a[sortBy] < b[sortBy]) ? -1 : 1
        });
    };

    this.sortVisits = function (sortBy, direction, visits) {
        var fieldValid = false,
            directionValid = false;

        for(var fieldName in fieldNames){
            if(fieldNames[fieldName] === sortBy) {
                fieldValid = true;
                break;
            }
        }

        if(!fieldValid){
            sortBy = fieldNames.TIME_IN;
            console.warn("Invalid sort option provided. Defaulting to sort by timeIn.");
        }

        for(var directionName in sortDirection){
            if(sortDirection[directionName] === direction) {
                directionValid = true;
                break;
            }
        }

        if(!directionValid){
            direction = sortDirection.DESC;
            console.warn("Invalid sort direction provided. Defaulting to sort descending.");
        }

        var secondary = (sortBy === 'userName') ? 'timeIn' : 'userName';

        return visits.sort(function (a, b) {
            if (a[sortBy] === b[sortBy]) {

                if(a[secondary] === b[secondary]){
                    return 0;
                }

                if(secondary === 'userName') {
                    return (a[secondary] < b[secondary]) ? -1 : 1;
                }else{
                    return (a[secondary] > b[secondary]) ? -1 : 1;
                }
            }

            if(direction === sortDirection.DESC) {
                return (a[sortBy] > b[sortBy]) ? -1 : 1;
            }else{
                return (a[sortBy] < b[sortBy]) ? -1 : 1;
            }
        });
    };

    onsiteSettingsService.getOnSiteSettingsByLogId($rootScope.selectedLog.id).then(function(settings){
       masterDisplayOptions.levelOneWarning = settings.levelOneWarning;
       masterDisplayOptions.levelTwoWarning = settings.levelTwoWarning;
    });

}

angular.module("onsite").service("onsiteUiFilterService", ['$rootScope', 'onsiteSettingsService', OnsiteUiFilterService]);
